<div class="page-header">
    <a routerLink="/nieuws/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "news.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-news-detail-form [news]="news$ | async" (submitted)="submit($event)" [errors]="(errors$ | async)!" [loading]="(loading$ | async)!"/>